import { RESET_OUT_OF_DELIVERY_ERROR } from '../actionTypes';

const resetOutOfDeliveryError = () => ({ type: RESET_OUT_OF_DELIVERY_ERROR });

export default resetOutOfDeliveryError;
